import axios from 'axios'
import { message, Modal } from 'ant-design-vue'
import { router } from '@/router/index'

const services = axios.create({
  // baseURL: 'http://192.168.1.99:3002', // 君琪
  // baseURL: "http://8.134.239.74:8002", // 线上
  // baseURL: 'http://8.134.131.208:3022/prod-api', // 线上
  
  baseURL: 'http://hlnew.cpolar.top', // 新线上地址 
  timeout: 10 * 1000,
})
const baseURL = services.defaults.baseURL

export { baseURL }
// 请求拦截
services.interceptors.request.use(
  (config) => {
    const token = window.sessionStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截
services.interceptors.response.use(
  (response) => {
    const res = response.data

    if (res.code !== 200) {
      if (res.code === 401) {
        const token = window.sessionStorage.getItem('token')

        window.sessionStorage.removeItem('token')
        if (token) {
          Modal.info({
            title: '您的登录已过期',
            content: '点击确定刷新页面',
            okText: '确定',
            onOk() {
              window.location.reload()
            },
          })
        } else {
          message.error('未登录')
          router.replace('/')
        }
        return Promise.reject('登录过期')
      }
      const msg = res.msg || '未知错误，请联系管理员查看'

      console.error('[api]', msg)

      /** @type {RequestConfig} */
      const config = response.config
      if (config.isShowError) {
        message.error(msg.length < 50 ? msg : '请求错误，请联系管理员查看')
      }

      return Promise.reject(msg)
    }

    // return res.data
    return res
  },
  (error) => {
    const { response } = error
    if (response && response.data) {
      return Promise.reject(error)
    } else {
      const { message } = error
      console.error('[api]', message)
      return Promise.reject(error)
    }
  }
)

export default services
